(function () {

    "use strict";

    angular
        .module("app")
        .factory("SeasonService", SeasonService);

    function SeasonService($http, $q, $rootScope, WebApiService) {

        var service = {

            getSeasonsByBrand: getSeasonsByBrand,
            getShiftCarryoverSeasonsByBrand: getShiftCarryoverSeasonsByBrand,
            getSubSeasons: getSubSeasons,
            getSeasons: getSeasons,
            getProjectsSeasons: getProjectsSeasons
        };

        return service;

        function getSeasonsByBrand(brandId, seasonsAfterThisSeasonId) {
            var url = "/api/Season/GetSeasonsByBrand?BrandId=" + brandId + "&seasonsAfterThisSeasonId=";
            if (seasonsAfterThisSeasonId)
                url += seasonsAfterThisSeasonId;
            return WebApiService.get(url);
        }

        function getShiftCarryoverSeasonsByBrand(brandId, seasonsAfterThisSeasonId) {
            var url = "/api/Season/GetShiftCarryoverSeasonsByBrand?BrandId=" + brandId + "&seasonsAfterThisSeasonId=";
            if (seasonsAfterThisSeasonId)
                url += seasonsAfterThisSeasonId;
            return WebApiService.get(url);
        }


        function getSubSeasons(seasonId) {
            return WebApiService.get("/api/SubSeason/SubSeasons?SeasonId=" + seasonId);
        }

        function getSeasons() {
            return WebApiService.get("/api/Season/GetSeasons");
        }

        function getProjectsSeasons(projId, projLevel) {
            return WebApiService.get("/api/Season/GetProjectsSeasons?projId=" + projId + "&projLevel=" + projLevel);
        }
        
    }


})();
